import { h, JSX } from '@stencil/core';
import { ScheduledScreen } from '@shared/types';

type ScreenKind = 'livestream' | 'countdown' | 'slideshow' | 'markdown' | 'reload';

type Renderer = (screen: ScheduledScreen) => JSX.Element;

export const ScreenRenderers: Record<ScreenKind, Renderer> = {
  livestream() {
    return <livestream-screen />;
  },
  countdown(screen: ScheduledScreen) {
    return <countdown-screen screen={screen} />;
  },
  slideshow(screen: ScheduledScreen) {
    return <slideshow-screen screen={screen} />;
  },
  markdown(screen: ScheduledScreen) {
    return <markdown-screen screen={screen} />;
  },
  reload() {
    setTimeout(() => location.reload(), 1000);
    return (
      <div class="row align--center">
        <h1>Reloading...</h1>
      </div>
    );
  },
}
